// extracted by mini-css-extract-plugin
export default {"list":"TemplateList_list__Sud-A"};